// SPDX-FileCopyrightText: 2025 Sequent Tech Inc <legal@sequentech.io>
//
// SPDX-License-Identifier: AGPL-3.0-only
import { EEnableCheckableLists } from "@sequentech/ui-core";
export var isCandidateACheckableList = function (candidate) {
    var _a;
    var candidatePresentation = candidate.presentation;
    return (_a = candidatePresentation === null || candidatePresentation === void 0 ? void 0 : candidatePresentation.is_category_list) !== null && _a !== void 0 ? _a : false;
};
export var filterCandidateByCheckableLists = function (candidate, contestCheckableLists) {
    if (isCandidateACheckableList(candidate)) {
        return [
            EEnableCheckableLists.CANDIDATES_AND_LISTS,
            EEnableCheckableLists.LISTS_ONLY,
        ].includes(contestCheckableLists);
    }
    else {
        return [
            EEnableCheckableLists.CANDIDATES_AND_LISTS,
            EEnableCheckableLists.CANDIDATES_ONLY,
        ].includes(contestCheckableLists);
    }
};
